import Vue from 'vue';
import Dialog from 'primevue/dialog';

Vue.component('Dialog', Dialog);
